/* RESPONSIBLE TEAM: team-proactive-support */
import Controller from '@ember/controller';

export default class PreTourController extends Controller {
  currentUrl = undefined;
  tooltips = false;
  queryParams = [{ currentUrl: 'current_url', tooltips: false }];
}
